import React, { useEffect, useState, useCallback } from "react";
import { ChronosDate } from "../_helpers";
import { useSelector } from "react-redux";
import { TimelineEvent } from "./";
import bigInt from "big-integer";
import { useContextMenu } from "react-contexify";
import { useApp, useMaps } from "../_contexts";

export function TimelineLane({
  laneID,
  timelineID,
  chronicle,
  currentDate,
  calendar,
  granularity,
  containerRef,
}) {
  console.log("Timeline Lane render!");
  const { openPopup, openSidebar, closePopup, closeSidebar, editMode } = useApp();
  const { goToMap, goTo, currentMap, getCurrentMap } = useMaps();
  const { items: maps } = useSelector((state) => state.maps);
  //Get Events and Markers from redux store
  const { items: events } = useSelector((state) => state.event);
  const { items: markers } = useSelector((state) => state.markers);
  const { items: eventTypes } = useSelector((state) => state.eventTypes);

  const { show } = useContextMenu({
    id: "chronos-new-event-context-menu",
    props: {},
  });

  //Setup state to hold children to render.
  const [filteredEvents, setFilteredEvents] = useState([]);

  //Destructure the number of granularity units to display
  const { unitDisplayCount } = chronicle;

  const handleClick = useCallback(
    async (event, type) => {
      if (type !== "bundle") {
        // console.log("Get Current Map: ", event);
        const markerID =
          event && event.marker
            ? typeof event.marker !== "string"
              ? event.marker._id
              : event.marker
            : null;
        if (markerID !== null) {
          const marker = await markers.find((m) => m._id === markerID);
          // console.log("Found Marker!", marker, markerID, markers);
          if (marker && marker.parentMap !== null) {
            const map = await maps.find((m) => m._id === marker.parentMap);
            if (map) {
              // console.log('Found Map!', map)
              const { coords } = marker;
              const newCoords = {
                ...coords,
                z: map && map.options ? map.options.zoomMax : coords.z,
              };
              goToMap(map._id, newCoords);
            }
            // does the issue occur when creating new markers/events and then linking?
          }
        }
      }
    },
    [markers, maps]
  );
  // console.log('Lane Rendered', laneID, currentDate, granularity);

  //Setup Context Menu for timelane, setup dateCalcFromPosition here as
  //separate function so you can pass it into the TimelineEvents

  const getDateFromPosition = (ev) => {
    const parentNode = ev.target.closest('.chronos-timeline-slots');

    const offsetLeft = parentNode.offsetLeft;
    const mouseX = ev.clientX + containerRef.current.scrollLeft - offsetLeft;
    // const step = Math.floor(mouseX / 15);

    const segmentDate = new ChronosDate(currentDate, { calendar });
    const segmentData = segmentDate.getTimelineSegment(granularity, {
      unitCountDisplay: unitDisplayCount,
    });

    const laneStartDate = segmentData.start;

    const startDate = segmentDate.getDateFromPosition(
      mouseX,
      granularity,
      segmentData.start,
      unitDisplayCount
    );
    // console.log('LANE: ', startDate)
    return {
      eventDate: startDate,
      laneStart: laneStartDate,
    };
  };

  const handleContextClick = (ev) => {
    if (!editMode) return;
    ev.preventDefault();
    ev.stopPropagation();
    const { eventDate } = getDateFromPosition(ev);

    const newEventItem = {
      fromDate: eventDate,
      timeline: timelineID,
      lane: laneID,
      chronicle,
    };
    // console.log('New Event Item', newEventItem);
    show(ev, {
      props: {
        eventItem: newEventItem,
      },
    });
  };

  const generateTimelineEvents = useCallback(() => {
    //Get Segment (viewable timespan) data
    const segmentDate = new ChronosDate(currentDate, { calendar });
    const segmentData = segmentDate.getTimelineSegment(granularity, {
      unitCountDisplay: unitDisplayCount,
    });
    // console.log('Timelane Segment', segmentData);
    //Destructure the Segment start and end dates
    const { start, end } = segmentData;

    //Get all events for the current lane (regardless of date)
    //We ignore date here because we want to include Ranged Events
    //that may start before the current Segment.
    let laneEvents = events.filter(
      (ev) => ev.lane === laneID && ev.timeline === timelineID
    );

    // console.log('ALL EVENTS TIMELINE', [...laneEvents], timelineID);

    //Process list of Lane Events
    for (let i = 0; i < laneEvents.length; i++) {
      //Get current iteration Event
      let laneEvent = laneEvents[i];
      //Clone the Event into a new object so we can add/remove properties
      //that are needed by TimelineEvent component (we do NOT want to
      //accidently modify the source event in redux state!!)
      const event = {
        ...laneEvent,
        laneStart: start,
        laneEnd: end,
      };

      //If the laneEvent has an end date, we'll need to calculate how it can
      //be displayed: START, END, SPAN, CONTAIN
      if (laneEvent.toDate !== null) {
        event.view = "";
      }

      //If the Event has a Marker assigned, we'll need that data so we can
      //pass it down to the TimelineEvent
      if (event.marker && typeof event.marker === "string") {
        event.marker = markers.find((m) => m._id === event.marker);
      }

      //Determine if the current Lane Event spans time
      const isRange = event.toDate !== null && event.toDate !== event.fromDate;

      //Create a new Date reference to perform calculations
      const eventDate = new ChronosDate(event.fromDate, { calendar });
      // console.log('Lane Events', laneEvents);
      if (!isRange) {
        //If the Event is a single Instance (not a Ranged event),
        //We need to determine if it shows during the current Segment.

        // console.log(`Event ${event.title} is not a range`);
        if (eventDate.isBetween(start, end)) {
          //The current Event is within the current Segment
          // console.log(
          //   `Event "${event.title}" is present in segment ${start}-${end}`
          // );

          //Apply the modified Event data to the current Lane Event
          laneEvents[i] = event;
          //Skip remaining processing
          continue;
        } else {
          //The current Event is NOT in the current Segment
          // console.log(
          //   `Event "${event.title}" is NOT present in segment ${start}-${end}`
          // );
          laneEvents[i] = undefined;
          //Skip remaining processing
          continue;
        }
      } else {
        //The Event is a RangedEvent, so we need to do some additional calculation
        // console.log(`Event ${event.title} is a range`);

        //Get a Date reference to the Event's end date
        const eventEndDate = new ChronosDate(event.toDate, { calendar });

        //Check for a ranged event that starts before but ends during the current segment
        if (
          eventDate.isBefore(start) &&
          eventEndDate.isAfter(start) &&
          eventEndDate.isBefore(end)
        ) {
          event.view = "END";
          // console.log(`Event ${event.title} has view ${event.view}`);

          //Apply the modified Event to the current Lane Event
          laneEvents[i] = event;
          //Skip remaining processing
          continue;
        }

        //Check for ranged event that starts before and ends after the current segment
        if (eventDate.isBefore(start) && eventEndDate.isAfter(end)) {
          event.view = "SPAN";
          // console.log(`Event ${event.title} has view ${event.view}`);

          //Apply the modified Event to the current Lane Event
          laneEvents[i] = event;
          //Skip remaining processing
          continue;
        }

        //Check for ranged Event that starts during but ends after the current segment
        if (
          eventDate.isAfter(start) &&
          eventDate.isBefore(end) &&
          eventEndDate.isAfter(end)
        ) {
          event.view = "START";
          // console.log(`Event ${event.title} has view ${event.view}`);

          //Apply the modified Event to the current Lane Event
          laneEvents[i] = event;
          //Skip remaining processing
          continue;
        }

        //Check for ranged Event that starts and ends during current segment
        if (
          eventDate.isBetween(start, end) &&
          eventEndDate.isBetween(start, end)
        ) {
          event.view = "CONTAIN";
          // console.log(`Event ${event.title} has view ${event.view}`);

          //Apply the modified Event to the current Lane Event
          laneEvents[i] = event;
          //Skip remaining processing
          continue;
        }

        //If the Event Range is not in the current view, we should delete it
        if (!event.view || event.view === "") {
          // console.log(`Event ${event.title} has no view!`);
          laneEvents[i] = undefined;
        }
      }
    }

    //Quickly run through current Lane Events and remove any deleted Events
    laneEvents = laneEvents
      .filter((le) => le !== undefined)
      .sort((a, b) => {
        return bigInt(a.fromDate).compare(b.fromDate);
      });

    // console.log(`Lane ${laneID} Events (mid-process)`, laneEvents);

    //Setup bundles array
    let eventBundles = [];
    //Setup history of checked Events
    let checkedEvents = [];

    //We need to bundle any Events that are not RangedEvents and take place
    //in the same granularity step
    laneEvents.forEach((itemA, i) => {
      //Create a copy of the item so we don't accidently mutate the original
      let eventA = { ...itemA };

      //Check if the Event has already been processed
      if (checkedEvents.indexOf(eventA._id) > -1) {
        return;
      }

      if (eventA.category !== null) {
        eventA.eventType =
          eventTypes.find((t) => t._id === eventA.category) || false;
        // console.log("EventA CategoryID", eventA);
      }
      // console.log(eventA.title);
      //Create an EventBundle consisting of just this Event. This will have
      //other events added if they match the granularity step (are displayed
      //in the same location on the Timeline based on Date and granularity)
      let eventBundle = [eventA];

      //Get a reference Date of the beginning of the Event
      let eventAStart = new ChronosDate(eventA.fromDate, { calendar });

      //Check if the Event is a RangedEvent
      let isEventARanged = eventA.toDate !== null;

      if (isEventARanged) {
        //If the Event is a RangedEvent, we want to determine if the Event
        // should be treated as a single event. If it spans a single
        // granularity unit, we should treat it as a single Event and allow
        // it to be bundled.
        const eventRange = eventAStart.getUnitDifference(
          eventA.toDate,
          granularity
        );
        // console.warn('EVENT RANGE', eventRange, eventA.title);
        // console.log(`Event ${eventA.title} spans ${eventRange} ${granularity}`);

        if (Math.abs(eventRange) > 1) {
          //Event is being added as a standalone TimelineEvent. Add to list
          //of checked events, and add the TimelineEvent as a 'bundle' (of
          //one Event)
          checkedEvents.push(eventA._id);
          eventBundles.push(
            <TimelineEvent
              events={[eventA]}
              step={granularity}
              calendar={calendar}
              parentRef={containerRef}
              timeline={timelineID}
              laneID={laneID}
              chronicle={chronicle}
              laneStart={start}
              laneEnd={end}
              granularity={granularity}
              key={i}
              getDate={getDateFromPosition}
              openSidebar={openSidebar}
              openPopup={openPopup}
              closeSidebar={closeSidebar}
              closePopup={closePopup}
              isEditable={editMode}
              // maps={maps}
              // markers={markers}
              // goTo={goTo}
              // goToMap={goToMap}
              // currentMap={currentMap}
              handleClick={handleClick}
              // currentMap={getCurrentMap()}
            />
          );
          //Skip remaining processing
          return;
        } else {
          //The RangedEvent is only a single unit, so we're going to treat it
          //as an InstanceEvent and continue calculating as such.
          eventA.overrideSpan = true;
        }
      }
      // console.log(`Event ${eventA.title} is not a span`);

      //Next, we need to find any Events that have not yet been checked to
      //see if they fall in the same granularity unit of the Segment
      laneEvents.forEach((itemB) => {
        //First, we create a clone of the Event we're comparing to prevent
        //accidental mutation.
        let eventB = { ...itemB };

        //We're also going to skip this Event if it is a RangedEvent, as
        //we'll get to it in the parent loop.
        if (eventB.toDate !== null && !eventB.overrideSpan) {
          return;
        } else {
          // console.log('EVENT:', { eventA, eventB });
        }
        if (eventB.category !== null) {
          eventB.eventType =
            eventTypes.find((t) => t.__id === eventB.category) || false;
        }
        // console.log('A: ', eventA);
        // console.log('B: ', eventB);
        //Skip processing if this event has been checked or is the current
        //Event from the parent loop.
        if (
          eventA._id === eventB._id ||
          checkedEvents.indexOf(eventB._id) > -1
        ) {
          // console.log('Not Bundling due to prior match', eventB.title);
          return;
        }

        // console.log("A: ", eventA);
        // console.log("B: ", eventB);

        //Get a new Date reference to this Event's start date
        const eventBStart = new ChronosDate(eventB.fromDate, { calendar });
        const aUnits = eventAStart.getUnits(granularity);
        const bUnits = eventBStart.getUnits(granularity);

        if (aUnits === bUnits) {
          checkedEvents.push(eventB._id);
          eventBundle.push(eventB);
        }
      });
      // console.log('EVENT BUNDLE: ', eventBundle);

      //We're done with this Event, so add it to the history of checked
      //Events, and add a TimelineEvent with the current event bundle to
      //the list of bundles to render
      checkedEvents.push(eventA._id);
      eventBundles.push(
        <TimelineEvent
          events={eventBundle}
          step={granularity}
          calendar={calendar}
          parentRef={containerRef}
          timeline={timelineID}
          laneID={i}
          chronicle={chronicle}
          laneStart={start}
          laneEnd={end}
          granularity={granularity}
          key={i}
          getDate={getDateFromPosition}
          openSidebar={openSidebar}
          openPopup={openPopup}
          closeSidebar={closeSidebar}
          closePopup={closePopup}
          isEditable={editMode}
          // maps={maps}
          // markers={markers}
          // goTo={goTo}
          // goToMap={goToMap}
          // currentMap={currentMap}
          handleClick={handleClick}
          // currentMap={getCurrentMap()}
        />
      );
    });

    //We're done calculating the Events for this Lane, so we'll update
    //the state with the list of TimelineEvents to render.
    setFilteredEvents(eventBundles);
  }, [events, currentDate, granularity, maps, markers]);

  //We need to parse the Events to determine which ones to display,
  //based on the current Segment and Lane.
  useEffect(() => {
    generateTimelineEvents();
  }, [events, currentDate, granularity, markers, maps]);

  return (
    <div className="chronos-timeline-lane" onContextMenu={handleContextClick}>
      {filteredEvents}
    </div>
  );
}
